/**
 * Projects Block Client Component
 * Client-side wrapper for BlockLayout that handles rendering
 * Receives projects data from Server Component
 */

'use client';

import { BlockLayout } from '@/components/blocks/BlockLayout';
import type { ProjectTeaserType } from '../types/project';
import { ProjectCard } from './project-card';

interface ProjectsBlockClientProps {
  /** Projects data */
  projects: ProjectTeaserType[];
  /** Optional title for the block */
  title?: string;
  /** Empty state message */
  emptyMessage?: string;
  /** Width of each item in pixels for horizontal layout */
  itemWidth?: number;
}

export function ProjectsBlockClient({
  projects,
  title = 'Projects',
  emptyMessage = 'No projects available at the moment.',
  itemWidth = 320,
}: ProjectsBlockClientProps) {
  return (
    <BlockLayout<ProjectTeaserType>
      title={title}
      data={projects}
      renderItem={(project) => (
        <ProjectCard
          key={project.id}
          project={project}
          imageSizes={`(max-width: 640px) 100vw, ${itemWidth}px`}
        />
      )}
      loading={false}
      error={null}
      showEmptyState={false}
      emptyMessage={emptyMessage}
      itemWidth={itemWidth}
    />
  );
}
